import React from 'react';
import MessageOutlineIcon from 'mdi-react/MessageOutlineIcon';

const copyCommunicationHistoryTooltip = (aboutLabel) => (
  <div className="lp-info-tooltip__section">
    <div className="lp-info-tooltip__heading-row">
      <span className="lp-info-tooltip__heading-text">
        Copy Communication History
      </span>
    </div>
    <div className="lp-info-tooltip__body">
      <strong>
        Click the icon to copy the communication history with a Pet Parent about{' '}
        {aboutLabel}. You can then paste the history elsewhere.
      </strong>
      <br />
      <br />
      The communication history includes messages and attachments:
      <br />
      (i) sent by a Pet Parent using the Loyal Pet mobile app on their phone
      <br />
      (ii) sent to a Pet Parent using the <em>Message</em> link in the Web app.
    </div>
  </div>
);

const sendMessageToPetParentTooltip = (aboutLabel) => (
  <div className="lp-info-tooltip__section">
    <div className="lp-info-tooltip__heading-row">
      <MessageOutlineIcon
        size={16}
        className="lp-info-tooltip__heading-icon"
        aria-hidden
      />
      <span className="lp-info-tooltip__heading-text">
        Send Message to Pet Parent
      </span>
    </div>
    <div className="lp-info-tooltip__body">
      <strong>
        Click the <em>Message</em> link to send a message to a Pet Parent about
        their {aboutLabel}.
      </strong>
      <br />
      <br />
      The message is received by the Pet Parent on their mobile phone as both:
      <br />
      (i) a Newsfeed post in the Loyal Pet mobile app
      <br />
      (ii) a push notification.
    </div>
  </div>
);

const COPY_COMM_HISTORY_REFILL_HEADER_TOOLTIP =
  copyCommunicationHistoryTooltip('a Refill Request');

const COPY_COMM_HISTORY_APPOINTMENT_REQUEST_HEADER_TOOLTIP =
  copyCommunicationHistoryTooltip('an Appointment Request');

const COPY_COMM_HISTORY_INQUIRY_HEADER_TOOLTIP =
  copyCommunicationHistoryTooltip('an Inquiry');

const SEND_MESSAGE_REFILL_HEADER_TOOLTIP =
  sendMessageToPetParentTooltip('Refill Request');

const SEND_MESSAGE_APPOINTMENT_REQUEST_HEADER_TOOLTIP =
  sendMessageToPetParentTooltip('Appointment Request');

const SEND_MESSAGE_INQUIRY_HEADER_TOOLTIP =
  sendMessageToPetParentTooltip('Inquiry');

// Temporary aliases (safe if anything still imports the old names).
const COPY_MESSAGE_HISTORY_HEADER_TOOLTIP =
  COPY_COMM_HISTORY_REFILL_HEADER_TOOLTIP;

const SEND_MESSAGE_TO_PET_PARENT_HEADER_TOOLTIP =
  SEND_MESSAGE_REFILL_HEADER_TOOLTIP;

export {
  COPY_COMM_HISTORY_REFILL_HEADER_TOOLTIP,
  COPY_COMM_HISTORY_APPOINTMENT_REQUEST_HEADER_TOOLTIP,
  COPY_COMM_HISTORY_INQUIRY_HEADER_TOOLTIP,
  SEND_MESSAGE_REFILL_HEADER_TOOLTIP,
  SEND_MESSAGE_APPOINTMENT_REQUEST_HEADER_TOOLTIP,
  SEND_MESSAGE_INQUIRY_HEADER_TOOLTIP,
  COPY_MESSAGE_HISTORY_HEADER_TOOLTIP,
  SEND_MESSAGE_TO_PET_PARENT_HEADER_TOOLTIP,
};
